<template>
  <svg :style="iconStyle">
    <use :xlink:href="symbolId" />
  </svg>
</template>

<script setup>
import vw from '@/utils/inline-px-to-vw'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  notNeedFill: {
    type: Boolean,
    default: false,
  },
  fill: {
    type: String,
    default: '#fff',
  },
  fillSecondary: {
    type: String,
    default: '#fff',
  },
  opacity: {
    type: Array,
    default: () => [],
  },
  size: {
    type: [String, Number, Array],
    default: '20px',
  },
  prefix: {
    type: String,
    default: 'icon',
  },
})

const symbolId = computed(() => `#${props.prefix}-${props.name}`)

const iconStyle = computed(() => {
  let width, height
  if (Array.isArray(props.size)) {
    width = vw(props.size[0])
    height = vw(props.size[1])
  } else {
    width = vw(props.size)
    height = width
  }

  return {
    width,
    height,
    fill: props.notNeedFill ? 'none' : 'currentColor',
    '--icon-color': props.fill,
    '--icon-color-secondary': props.fillSecondary,
    '--opacity-1': props.opacity[0],
    '--opacity-2': props.opacity[1],
  }
})
</script>

<style scoped>
svg {
  vertical-align: middle;
  overflow: hidden;
}
</style>
